import { useMutation } from 'react-query';
import api from 'src/services/api';

export const useUploadQuestions = () => useMutation((formData) => api.postForm('/company/questions/questions', formData));

export const useUploadCategories = () => useMutation((formData) => api.postForm('/company/questions/categories', formData));

export const useUploadRoles = () => useMutation((formData) => api.postForm('/company/questions/roles', formData));
